import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';

import * as Client from 'api/client';
import { useAuth } from 'providers/Auth';
import { useToast } from 'providers/Toast';
import { getMobileNumber } from 'utils/method';
import Context from './Context';

const Provider = ({ children }) => {
  const { auth, saveClient } = useAuth();
  const { danger } = useToast();
  const [occpations, setOccpations] = useState([]);
  const [locations, setLocations] = useState([]);
  const intl = useIntl();
  const errorMsg = intl.formatMessage({ id: 'error_msg' });
  const [searchParams] = useSearchParams();
  const agentId = searchParams.get('agentId') || '';

  const createClient = async (details) => {
    const {
      companyName = '',
      email,
      occupation,
      city,
      address,
      phone,
      name,
      firstName,
      lastName,
      caseName,
      sourceSales,
      // needSales,
    } = details;
    const { day, month, year } = details;
    let birthday = '';
    if (year && month && day) birthday = `${year}/${month}/${day}`;
    return saveClient({
      lineId: auth.userId,
      agentId,
      birthday,
      name: name,
      mobile: getMobileNumber(phone),
      companyName,
      email: email || '',
      occupation,
      city,
      address,
      firstName,
      lastName,
      caseName,
      sourceSales,
      // note: needSales ? '我需要專員服務' : '',
    });
  };

  const getOccpations = () => {
    return Client.getOccpations().then((res) => {
      console.log(res);
      if (res.err) danger(errorMsg);
      else setOccpations(res.data);
      return res.data;
    });
  };
  const getLocations = () => {
    return Client.getLocations().then((res) => {
      console.log(res);
      if (res.err) danger(errorMsg);
      else setLocations(res.data);
      return res.data;
    });
  };

  const props = {
    createClient,
    getOccpations,
    getLocations,
    occpations,
    locations,
  };
  return <Context.Provider value={{ ...props }}>{children}</Context.Provider>;
};

export default Provider;
